import React from 'react';

const GameSettings = ({ 
  selectedCategory, 
  setSelectedCategory, 
  selectedDifficulty, 
  setSelectedDifficulty, 
  questionCount, 
  setQuestionCount, 
  muted, 
  setMuted 
}) => {
  const categories = [
    { id: 9, name: "General Knowledge" },
    { id: 17, name: "Science & Nature" },
    { id: 18, name: "Science: Computers" },
    { id: 19, name: "Science: Mathematics" },
    { id: 20, name: "Mythology" },
    { id: 21, name: "Sports" },
    { id: 22, name: "Geography" },
    { id: 23, name: "History" },
    { id: 24, name: "Politics" },
    { id: 25, name: "Art" },
    { id: 26, name: "Celebrities" },
    { id: 27, name: "Animals" },
    { id: 28, name: "Vehicles" }
  ];
  
  const difficulties = [
    { id: 'easy', name: 'Easy', color: '#4CAF50' },
    { id: 'medium', name: 'Medium', color: '#FF9800' },
    { id: 'hard', name: 'Hard', color: '#F44336' }
  ];

  return (
    <div className="game-settings">
      <div className="setting-group">
        <label>Category:</label>
        <select 
          value={selectedCategory} 
          onChange={(e) => setSelectedCategory(parseInt(e.target.value))}
          className="setting-select"
        >
          {categories.map(cat => (
            <option key={cat.id} value={cat.id}>{cat.name}</option>
          ))}
        </select>
      </div>
      
      <div className="setting-group">
        <label>Difficulty:</label>
        <div className="difficulty-buttons">
          {difficulties.map(diff => (
            <button
              key={diff.id}
              className={`difficulty-btn ${selectedDifficulty === diff.id ? 'active' : ''}`}
              style={{ backgroundColor: selectedDifficulty === diff.id ? diff.color : '#f0f0f0' }}
              onClick={() => setSelectedDifficulty(diff.id)}
            >
              {diff.name}
            </button>
          ))}
        </div>
      </div>
      
      <div className="setting-group">
        <label>Questions: {questionCount}</label>
        <input
          type="range"
          min="5"
          max="20"
          value={questionCount}
          onChange={(e) => setQuestionCount(parseInt(e.target.value))}
          className="question-slider"
        />
      </div>
      
      <div className="setting-group">
        <button 
          className={`mute-btn ${muted ? 'muted' : ''}`}
          onClick={() => setMuted(!muted)}
        >
          {muted ? '🔇 Muted' : '🔊 Sound On'}
        </button>
      </div>
    </div>
  );
};

export default GameSettings;
